import {
  logError as sharedLogError,
  logWarning as sharedLogWarning,
  getErrorMessage,
} from '@/utils/errorUtils'

export { getErrorMessage }

/**
 * Log an error with a consistent prefix for the OrderTests module.
 * Always call this alongside any user-facing notification so the full
 * error (including stack trace) is available in the browser console.
 */
export function logError(context: string, err: unknown): void {
  sharedLogError('order-tests', context, err)
}

/**
 * Log a warning for the OrderTests module at Sentry warning level.
 * Use for unexpected-but-valid states (e.g., empty search results).
 * Filter in Sentry with `level:warning` to view separately from errors.
 */
export function logWarning(context: string, detail: string): void {
  sharedLogWarning('order-tests', context, detail)
}
